import React from 'react'
import vertigo from './img/vertigo.png'
import minty from './img/minty.png'
import glossy from './img/glossy.png'
import wave from './img/wave.png'
import rise from './img/rise.png'

export default function PartnersAf() {
  return (
    <section className='partner'>
        <div className="container">
            <div className="row">
                <div className="col-md-3 partnerS">
                    <h2 className='text-white py-4 ps-4 fw-bold' data-aos="fade-up">
                    PARTNERS <span className='text-dark'>AFFILIATION</span>
                    </h2>
                </div>
                <div className="col-md-9">
                    <div className="row align-items-center py-5">
                        <div className="col-auto" data-aos="fade-up">
                            <img src={vertigo} alt="" className="img-fluid px-3" />
                        </div>

                        <div className="col-auto" data-aos="fade-up">
                            <img src={minty} alt="" className="img-fluid px-3" />
                        </div>

                        <div className="col-auto" data-aos="fade-up">
                            <img src={glossy} alt="" className="img-fluid px-3" />
                        </div>

                        <div className="col-auto" data-aos="fade-up">
                            <img src={wave} alt="" className="img-fluid px-3" />
                        </div>

                        <div className="col-auto" data-aos="fade-up">
                            <img src={rise} alt="" className="img-fluid px-3" />
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
